import { Redirect } from 'expo-router';
import { concatPath } from '../../utils/links/concatPath';
import { publicKey, tabsKey } from '../../constants/routeKeys';
import { registerKey } from '../../constants/routeKeys';

const LoginRegister = () =>{
  return(<Redirect href={concatPath([publicKey, tabsKey, registerKey])} />);

};

export default LoginRegister;